/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 14A7 7 0 107 0a7 7 0 000 14zM7 2a1 1 0 011 1v5a1 1 0 11-2 0V3a1 1 0 011-1zm0 10c.608 0 1.1-.448 1.1-1s-.492-1-1.1-1c-.608 0-1.1.448-1.1 1s.492 1 1.1 1z" _fill="#fff"/>'
  }
})
